// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__wUfnY","noInteraction":"EventWrapper_noInteraction__1cw7C"};